var _a, _b, _c, _d, _e, _f, _g;
import { __decorate, __metadata, __param } from "tslib";
import { CustomFieldsModel } from '@/domains/custom-fields/models/custom-fields-model.interface';
import { SelectedCustomFieldsModel } from '@/domains/custom-fields/models/selected-custom-fields-model.interface';
import { GetLayerFieldService } from '@/domains/custom-fields/services/get-layer-field-service.interface';
import { RemoveCustomFieldService } from '@/domains/custom-fields/services/remove-custom-field-service.interface';
import { ConfirmService } from '@/services/confirm-service.interface';
import { I18nService } from '@/services/i18n-service';
import { Message } from '@patsnap/tahiti-core/common/message';
import { inject, injectable } from 'inversify';
let RemoveCustomFieldCommandContribution = class RemoveCustomFieldCommandContribution {
    constructor(_i18nService, _removeCustomFieldService, _confirmService, _message, _getLayerFieldService, _selectedCustomFieldsModel, _customFieldsModel) {
        this._i18nService = _i18nService;
        this._removeCustomFieldService = _removeCustomFieldService;
        this._confirmService = _confirmService;
        this._message = _message;
        this._getLayerFieldService = _getLayerFieldService;
        this._selectedCustomFieldsModel = _selectedCustomFieldsModel;
        this._customFieldsModel = _customFieldsModel;
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'custom-field.remove',
            icon: 'SolidDelete',
            label: this._i18nService.t('global.btn.delete'),
        }, {
            execute: (context) => {
                return this._execute(context);
            },
        });
    }
    async _execute(context) {
        const message = await this._getConfirmMessage(context);
        const confirm = await this._confirmService.confirm({
            title: this._i18nService.t('workspace.confirmTitle.deleteCustomField'),
            message,
            description: this._i18nService.t('Readability.deleteTip'),
            confirmText: this._i18nService.t('global.btn.delete'),
            cancelText: this._i18nService.t('global.btn.cancel'),
            type: 'error',
        });
        if (confirm) {
            const customFieldIds = context.fields.map(field => field.field_id);
            await this._removeCustomFieldService.remove(customFieldIds);
            this._message.success({
                message: this._i18nService.t('global.deleteSuccess'),
            });
            this._selectedCustomFieldsModel.update((modelData) => {
                return modelData.filter(field => !customFieldIds.includes(field.field_id));
            });
            this._customFieldsModel.update((modelData) => {
                const fields = modelData.fields.filter(field => !customFieldIds.includes(field.field_id));
                modelData.fields = fields;
                modelData.counts = this._updateCounts(context, modelData.counts);
                return modelData;
            });
        }
    }
    _updateCounts(context, modelData) {
        if (context.isPublicMode) {
            return {
                customFieldCount: modelData.customFieldCount,
                publicCustomFieldCount: modelData.publicCustomFieldCount - context.fields.length,
            };
        }
        return {
            customFieldCount: modelData.customFieldCount - context.fields.length,
            publicCustomFieldCount: modelData.publicCustomFieldCount,
        };
    }
    async _getConfirmMessage(context) {
        if (context.fields.length === 1 && context.fields[0].field_type === 'LAYER') {
            const { name, nodeCount, usageCount } = await this._getLayerFieldService.getLayerField(context.fields[0].field_id);
            const message = this._i18nService.t('snapBusiness.layerTree.deleteConfirm', {
                name,
                childNodes: nodeCount,
                counts: usageCount,
            });
            return Promise.resolve(message);
        }
        const message = this._i18nService.t('fields.deleteCustomfieldDesc');
        return Promise.resolve(message);
    }
};
RemoveCustomFieldCommandContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __param(1, inject(RemoveCustomFieldService)),
    __param(2, inject(ConfirmService)),
    __param(3, inject(Message)),
    __param(4, inject(GetLayerFieldService)),
    __param(5, inject(SelectedCustomFieldsModel)),
    __param(6, inject(CustomFieldsModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object, typeof (_b = typeof RemoveCustomFieldService !== "undefined" && RemoveCustomFieldService) === "function" ? _b : Object, typeof (_c = typeof ConfirmService !== "undefined" && ConfirmService) === "function" ? _c : Object, typeof (_d = typeof Message !== "undefined" && Message) === "function" ? _d : Object, typeof (_e = typeof GetLayerFieldService !== "undefined" && GetLayerFieldService) === "function" ? _e : Object, typeof (_f = typeof SelectedCustomFieldsModel !== "undefined" && SelectedCustomFieldsModel) === "function" ? _f : Object, typeof (_g = typeof CustomFieldsModel !== "undefined" && CustomFieldsModel) === "function" ? _g : Object])
], RemoveCustomFieldCommandContribution);
export { RemoveCustomFieldCommandContribution };
